require('./dist/angular-strap.js');
require('./dist/angular-strap.tpl.min.js');
module.exports = 'mgcrea.ngStrap';



// WEBPACK FOOTER //
// ./app/vendor/angular-strap/index.js